import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/fp/get';
import setItemAttribute from '../../../../../actions/setItemAttribute';
import loading from '../../../../../actions/loading';
import loaded from '../../../../../actions/loaded';
import globalError from '../../../../../actions/globalError';

import ItemAttributes from './ItemAttributes';

const mapStateToProps = state => ({
  specMappings: get('estimateBuilder.mandiAvailability.specMappings')(state),
  windowCategoryMappings: get('estimateBuilder.mandiAvailability.windowCategoryMappings')(state),
  mountTypeMappings: get('estimateBuilder.mandiAvailability.mountTypes')(state),
});
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({
    setItemAttribute,
  }, dispatch),
  setLoading: value => (value
    ? dispatch(loading())
    : dispatch(loaded())
  ),
  globalError: err => dispatch(globalError({ err })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemAttributes);
